<script setup lang="ts">
import { useFetchGeneral } from '~/api/service/general/index.service'
import HomeGasInfoItem from '~/components/@pages/home/HomeGasInfoItem.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import { HOME_CHART_TOOLTIP } from '~/constants/general.const'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { generalParamType } from '~/types/general.type'

const { data, isLoading } = useFetchGeneral([ generalParamType.GAS ])
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/info.png`"
          alt="info skeleton"
        >
      </template>
      <template #default>
        <div class="gas-info-container">
          <HomeGasInfoItem
            color="#ff74fd"
            icon="gas-pump"
            label="Gas Price"
            :value="setComma(data.FGI.OBJ.LGP)"
            unit="Gwei"
            :tooltip="HOME_CHART_TOOLTIP[generalParamType.GAS].gasPrice"
          />
          <HomeGasInfoItem
            color="#5c8ffa"
            icon="oil-can"
            label="Base Fee (Avg)"
            :value="setComma(data.FGI.OBJ.AVGBF)"
            unit="Gwei"
            :tooltip="HOME_CHART_TOOLTIP[generalParamType.GAS].baseFee"
          />
          <HomeGasInfoItem
            color="#9c3eff"
            icon="water"
            label="Gas Used (Avg)"
            :value="setComma(data.FGI.OBJ.AVGGU)"
            :tooltip="HOME_CHART_TOOLTIP[generalParamType.GAS].gasUsed"
          />
        </div>
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped lang="scss">
.gas-info-container {
  @apply flex flex-col justify-between h-full;
}

</style>